<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-11 15:00:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-09 12:17:16
 * @FilePath:
 * @Description: 点击扫码(取号、点单等)之后自动跳转到该页面，执行取号操作
-->
<template>
  <div></div>
</template>

<script>
import {
  getScanTakeNumber,
  getScanCardBinderInfo,
  getScanTakeNumberInfo,
} from "@/api/scan";
import {
  applyBlackGoldenUIVersion,
  applyDevMockUseBlackGoldenUI,
  getBlackCurrentConsumeRouteName,
  getBlackInputPeopleNumRouteName,
  getBlackMicropointRouteName,
  getBlackRecordConsumeRouteName,
  getInputPeopleNumRouteName,
  handleSessionStorage,
  isBlackOrderFlag,
  setBlackOrderFlag,
} from "@/utils";
import { Dialog } from "vant";
export default {
  name: "TakeNumberResult",
  props: {},
  data() {
    return {
      backUrl: "",
      fromPage: "",
    };
  },
  components: {},
  beforeRouteEnter(to, from, next) {
    //在next中写处理函数
    next((vm) => {
      vm.fromPage = from.name;
    });
  },
  created() {
    this.$toast("数据加载中...");
    var pageQuery = this.$route.query;
    this.backUrl = pageQuery.backUrl || "";
    const actionQuery = pageQuery.action;

    if (!actionQuery) {
      //扫码取号 key/apply
      const orgString = pageQuery.M;
      const arr = orgString.split('@');
      if (arr instanceof Array && arr.length == 2) {
        this.uuid = arr[0],
          this.vpnCode = arr[1]
        handleSessionStorage.set("ScanResultVpnCode", this.vpnCode);
      }
      console.log("pageQuery 数据加载中 ==== " + this.uuid)
      // if (this.vpnCode) this.handleSetVpnInfo();
      this.handleSetScanResult();
    } else if (actionQuery == "takeorder") {
      //扫码点餐
      this.pQuery = pageQuery.p;
      this.diningRoomId = pageQuery.diningRoomId;
      if (this.diningRoomId) {
        handleSessionStorage.set("diningRoomId", this.diningRoomId);
      }
      this.deskInfoObj = {
        saasCode: pageQuery.vpncode,
        deskCode: pageQuery.tablecode,
      };
      const flag = this.pQuery ? "handcard" : "desk";
      this.startTakeOrderFlow(flag, pageQuery.vpncode);
    }
  },
  mounted() { },
  methods: {
    // handleSetVpnInfo() {
    //   const allVpnList = JSON.parse(localStorage.getItem("allStoreList"));

    //   const vpnItem = allVpnList.find((v) => {
    //     return v.SaaSCode === this.vpnCode;
    //   });
    //   if (vpnItem) {
    //     console.log("重新设置vpn");
    //     this.$store.commit("set_vpnid", vpnItem.Id);
    //     this.$store.commit("set_vpnInfo", {
    //       name: vpnItem.Name,
    //       code: vpnItem.SaaSCode,
    //       // payType: vpnItem.payType,
    //       Claims: vpnItem.Claims,
    //       ...vpnItem.SaasVpnSetting,
    //     });
    //   }
    // },
    handleSetScanResult() {
      getScanTakeNumber({
        BindingUuid: this.uuid,
        VpnCode: this.vpnCode,
      })
        .then((res) => {
          if (typeof res === "string") {
            handleSessionStorage.set("handCodeTips", res);
          } else {
            handleSessionStorage.remove("handCodeTips");
          }
          this.$router.push({ name: "ConsumeCodeInfo" });
        })
        .catch((err) => {
          const errMsg = err && err.message ? err.message : "";
          if (errMsg.indexOf("您已绑定手牌") != -1) {
            this.$router.push({ name: "ConsumeCodeInfo" });
          } else if (errMsg) {
            handleSessionStorage.set("handCodeTips", errMsg);
            this.$router.push({ name: "ConsumeCodeInfo" });
          }
        });
    },
    handleGetDeskInfo(flag) {
      // 如果this.fromPage == "Micropoint" 表示先点餐后扫餐台码的情况，此时扫完码需要跳转到订单提交页
      // const pageUrl =
      //   this.fromPage == "Micropoint" ? "NewPlaceOrder" : "Micropoint";
      var pageUrl = 'Micropoint'
      if (isBlackOrderFlag()) {
        pageUrl = getBlackMicropointRouteName()
      } else {
        pageUrl = 'Micropoint'
      }
      // 此时确认唯一门店，用于在进入点单页之后决定能否切换门店
      if (this.fromPage !== "Micropoint") {
        handleSessionStorage.set("isSureVpn", true);
      }
      const vpnInfo = handleSessionStorage.get("vpnInfo");
      getScanCardBinderInfo({
        OnlyGetBindingInfo: flag !== "handcard",
        TableArea: flag !== "handcard" ? this.deskInfoObj.deskCode : null,
        SaasVpnCode:this.fromPage == "Micropoint" && vpnInfo ? vpnInfo.code : flag !== "handcard" ? this.deskInfoObj.saasCode : null,
        QrCodeParaText: flag == "handcard" ? this.pQuery : null,
      }).then((res) => {

        // 当选餐门店与桌码门店不一致，弹窗提示
        res.Id = res.DiningRoomId
        handleSessionStorage.set("diningRoomInfo", res)
        handleSessionStorage.set("diningRoomId", res.DiningRoomId)
        handleSessionStorage.set('EnableTeamOrder', res.EnableTeamOrder)
        if (res.NoticeInfo) {
          return this.handleShowModal(res.SaasVpnCode);
        }
        if (flag == "handcard") {
          const deskCode = res.TableArea;
          const depart = res.DepartId;
          const checkinId = res.CheckinId;
          const cardCode = res.TableCode;
          if (deskCode) {
            handleSessionStorage.set("deskCode", {
              code: deskCode,
              depart,
              checkinId,
              cardCode,
            });
          }
        }
        handleSessionStorage.set("teamId", res.Team ? res.Team.Id : null);
        // this.$store.commit("set_deskcode", { code: deskCode, depart });

        if (res.HasGroupOrder) {
          //有订单则跳转到点单记录页
          if (isBlackOrderFlag()) {
            this.$router.push({
              name: getBlackRecordConsumeRouteName(),
            });
          } else {
            this.$router.push({
              name: "RecordsConsumption",
            });
          }

        } else if (res.Team && res.Team.PersonNum != 0) {
          // 团队点餐直接赋值之前选择的人数，进入点餐页
          this.$store.dispatch("order/SET_ORDER_PEOPLE", res.Team.PersonNum);
          //已选人数 再次进入
          this.$router.replace({
            name: pageUrl,
            query: {
              saasCode: res.SaasVpnCode,
              diningRoomId: this.diningRoomId,
            },
          });
        } else {
          if (this.$store.state.order.orderPeople) {
            // 非团队点餐，将之前选择人数清空，进入选择人数页
            this.$store.dispatch("order/SET_ORDER_PEOPLE", null);
          }
          const pushPage = this.resolvePeopleNumPushPage();
          this.$router.replace({
            name: pushPage,
            query: {
              fromPage: pageUrl,
              isFromMicropoint: this.fromPage == "Micropoint",
              saasCode: res.SaasVpnCode,
              diningRoomId: this.diningRoomId,
            },
          });
        }
      }).catch(error => {
        const pushPage = this.resolvePeopleNumPushPage();
        this.$router.replace({
          name: pushPage,
          query: {
            saasCode: this.vpnCode,
            diningRoomId: '',
          },
        });
      });
    },
    /** 扫码点餐：先拉门店配置再进入桌台绑定流程，避免 IS_BLACK_ORDER 未写入就跳转 */
    startTakeOrderFlow(flag, saasCode) {
      const tasks = [this.loadVpnInfo(saasCode)];
      if (
        flag === "desk" &&
        saasCode &&
        this.deskInfoObj &&
        this.deskInfoObj.deskCode
      ) {
        tasks.push(this.loadDeskScanInfo(saasCode, this.deskInfoObj.deskCode));
      }
      Promise.all(tasks).finally(() => {
        this.$nextTick(() => {
          this.handleGetDeskInfo(flag);
        });
      });
    },
    loadVpnInfo(saasCode) {
      if (!saasCode) return Promise.resolve(null);
      return $http(`wechath5/zh-cn/v1/vpn`)
        .then((res) => {
          const vpnItem1 = (res.Items || []).find((v) => v.SaaSCode === saasCode);
          if (!vpnItem1) return null;
          applyDevMockUseBlackGoldenUI(vpnItem1);
          applyBlackGoldenUIVersion(vpnItem1);
          const vpnInfo = {
            id: vpnItem1.Id,
            name: vpnItem1.Name,
            ...vpnItem1,
            ...vpnItem1.SaasVpnSetting,
          };
          setBlackOrderFlag(vpnInfo.UseBlackGoldenUI);
          localStorage.setItem("vpnInfo", vpnInfo);
          handleSessionStorage.set("vpnInfo", vpnInfo);
          return vpnInfo;
        })
        .catch(() => null);
    },
    loadDeskScanInfo(saasCode, deskCode) {
      return getScanTakeNumberInfo({ vpnCode: saasCode })
        .then((res) => {
          if (typeof res === "string") {
            handleSessionStorage.set("deskCode", { code: deskCode });
            return;
          }
          handleSessionStorage.set("deskCode", {
            code: deskCode,
            checkinId: res.CheckinId,
            cardCode: res.TableCode,
          });
        })
        .catch(() => {
          handleSessionStorage.set("deskCode", { code: deskCode });
        });
    },
    resolvePeopleNumPushPage() {
      let pushPage = getInputPeopleNumRouteName();
      if (
        !this.backUrl ||
        ![
          "NewPlaceOrder",
          "InputPeopleNum",
          "BlackInputPeopleNum",
          "BlackInputPeopleNumV2",
          "NewInputPeopleNum",
        ].includes(this.backUrl)
      ) {
        return pushPage;
      }
      if (this.backUrl === "NewPlaceOrder") {
        return isBlackOrderFlag()
          ? getBlackCurrentConsumeRouteName()
          : this.backUrl;
      }
      if (
        [
          "InputPeopleNum",
          "BlackInputPeopleNum",
          "BlackInputPeopleNumV2",
          "NewInputPeopleNum",
        ].includes(this.backUrl)
      ) {
        return isBlackOrderFlag()
          ? getBlackInputPeopleNumRouteName()
          : this.backUrl === "NewInputPeopleNum"
            ? "NewInputPeopleNum"
            : "InputPeopleNum";
      }
      return pushPage;
    },
    handleShowModal(code) {
      Dialog.confirm({
        message:
          "选餐门店与桌码门店不一致，是否切换到桌码门店？\n\n提示：切换门店后需重新点餐",
        messageAlign: "left",
        confirmButtonText: "切换门店",
      })
        .then(() => {
          // on confirm
          this.handleBindDesk(code);
        })
        .catch(() => {
          // on cancel
          if (isBlackOrderFlag()) {
            this.$router.replace({
              name: getBlackMicropointRouteName(),
            });
          } else {
            this.$router.replace({
              name: "Micropoint",
            });
          }

        });
    },
    handleBindDesk(saasCode) {
      //key/binder
      getScanCardBinderInfo({
        SaasVpnCode: saasCode,
        QrCodeParaText: this.pQuery,
      }).then((res) => {
        const deskCode = res.TableArea;
        const depart = res.DepartId;
        const checkinId = res.CheckinId;
        const cardCode = res.TableCode;
        if (deskCode) {
          handleSessionStorage.set("deskCode", {
            code: deskCode,
            depart,
            checkinId,
            cardCode,
          });
        }

        if (isBlackOrderFlag()) {
          this.$router.replace({
            name: getBlackMicropointRouteName(),
            query: { saasCode },
          });
        } else {
          this.$router.replace({
            name: "Micropoint",
            query: { saasCode },
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss"></style>
